import {USER_ORDER_FILTER_GET , USER_ORDER_FILTER_SUCCESS,USER_ORDER_FILTER_FAILURE } from './actions';

const initialState = {
    order:{}
}

export function UserOrderFilterReducer(state = initialState, action) {
    
    if(action.type === USER_ORDER_FILTER_GET) {
        return state;
    }
    if(action.type === USER_ORDER_FILTER_SUCCESS) {
        return {
            ...state,
            order: {
                isLoaded: true,
                data: action.payload,
                message: 'Success'
            }
        }
    }
    if(action.type === USER_ORDER_FILTER_FAILURE) {
        return {
            ...state,
            order: {
                data: [],
                message: action.payload
            }
        }
    }
    return state;
}

